import React from "react";
import PropTypes from "prop-types";

import SimpleHorizontalHeadersTable from "../../../../shared_components/simple_horizontal_headers_table";
import StandardsList from "../../containers/main_components/standards_list";
import { REGULATION_STANDARDS_ANCHOR_ID } from "../../actions/focus_view";

const makeIcons = tag => {
  const icon = tag.icon;
  const name = tag.name;
  if (icon) {
    return <img key={icon} className="tag-icon-image" title={name} data-original-title={name} src={icon} />;
  } else {
    return name;
  }
};
class RegulationDetail extends React.Component {
  render () {
    const regulationHref = reg => `${this.props.regulationBaseHref}?regulation_id=${reg.id}`;

    const r = this.props.regulation;
    const newTabIcon = <i className="fa fa-external-link"></i>;
    let related = "—";
    if (r.related.length > 0) {
      related = r.related.map((e, i) => <div key={i}><a href={regulationHref(e)} target="_blank">{e.name} {newTabIcon}</a></div>);
    }

    const applications = r.applications.map(makeIcons);
    const targets = r.targets.map(makeIcons);
    const standardsCount = this.props.standardsCount;

    const data = [
      ["Country", r.country],
      ["Region/State", r.region || "—"],
      ["Document name", r.name],
      ["Description", r.description],
      ["Year first passed", r.yearPassed],
      ["Year updated", r.yearUpdated],
      ["Application", applications],
      ["Target sectors", targets],
      ["Related regulations/legislation", related]
    ];

    let standardsList, standardsCountMessage;
    if (standardsCount > 0) {
      standardsList = <StandardsList />;
      standardsCountMessage = <h5>This regulation is associated with {this.props.standardsCount} standards</h5>;
    } else {
      standardsCountMessage = <h5>This regulation is not associated with any numerical standards</h5>;
    }

    return (
      <div className="regulation-detail">
        <SimpleHorizontalHeadersTable data={data} />
        <a id={ REGULATION_STANDARDS_ANCHOR_ID }></a>
        <h4>Associated numerical standards</h4>
        {standardsCountMessage}
        {standardsList}
      </div>
    );
  }
}

RegulationDetail.propTypes = {
  regulation: PropTypes.object.isRequired,
  standardsCount: PropTypes.number.isRequired,
  regulationBaseHref: PropTypes.string.isRequired
};

export default RegulationDetail;
